import Case from './Case'
import Client from './Client'
import DocumentEntity from './DocumentEntity'
import Query from './Query'
import User from './User'

export default {
  Case,
  Client,
  DocumentEntity,
  Query,
  User,
}
